module.exports = __webpack_public_path__ + "static/media/icon-facebook.1d813dc7.svg";